<script>
import apexchart from "vue-apexcharts";

export default {
    components: {
      apexchart,
    },
    props: {
      items: {
        type: Object,
        required: true,
      },
    },
  data() {
    return {
      series: this.items.series,
      chartOptions: {
        chart: {
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            ...(this.items.labels.length <= 3 ? { columnWidth: "100px" } : {}),
            endingShape: "rounded",
            dataLabels: {
              total: {
                enabled: true,
              },
          },
        },
       },
        xaxis: {
          categories: this.items.labels,
        },
        colors: ["#297358", "#f1b44c"],
        legend: {
          position: "bottom",
        },
        fill: {
          opacity: 1,
        },
      },
    };
  },
};
</script>
<template>
    <apexchart
      ref="chart"
      class="apex-charts"
      type="bar"
      dir="ltr"
      height="360"
      :series="series"
      :options="chartOptions"
    />
</template>